import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import { IColumnSort } from 'components/DataTable/types'
import { K12DistrictExportModal } from 'components/Modals/ExportModal/K12DistrictExportModal'
import { K12Filterset } from './K12Filterset'
import { useK12TableColumns } from './K12TableColumns'

const sortableFields: string[] = [
  'deal_count',
  'contact_count',
  'note_count',
  'sales_stages',
  'lea_name',
  'lcity',
  'lstate',
  'zipcode',
  'locale',
  'gslo',
  'gshi',
  'student_count',
  'teachers_count',
  'operational_schools',
  'revenue',
  'food_service_expenditures',
  'free_lunch',
  'reduced_lunch',
  'total_supplemented_lunch',
  'uncategorized_lunch',
  'free_lunch_perc',
  'reduced_lunch_perc',
  'total_supplemented_lunch_perc',
  'uncategorized_lunch_perc',
  'estimated_meals_per_day',
  'county',
]

export const k12TableConfig = defineTargetTableConfig({
  // K12 detail link reads `k12district.id` (see K12TableColumns name cell). App
  // vertical is `k12` for getTargetType (the `k12district` slug also maps to k12).
  vertical: 'k12',
  rowConfig: { nestKey: 'k12district' },
  filterIdentifier: 'K12_TABLE',
  savedPresetsIdentifier: 'K12_TABLE',
  companyTypeSlug: 'education-k-12',
  tableTypeSlug: 'education-k-12',
  sortableFields,
  defaultSort: [
    {
      id: 'k12district__estimated_meals_per_day',
      desc: true,
    } as IColumnSort<object>,
  ],
  preferredGroupOrder: [
    'Target Attributes',
    'School Insights',
    'Campaigns and Deals',
    'Dining Services',
  ],
  searchPlaceholder: 'Search schools by name',
  useColumns: useK12TableColumns,
  Filterset: K12Filterset,
  ExportModal: K12DistrictExportModal,
})

export function K12Table(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={k12TableConfig} {...props} />
}
